export const SITE = {
  name: 'W.B. Coin & Jewelry',
  legalName: 'West Bridgewater Coin and Jewelry Buyers LLC',
  tagline: 'Trusted buyers of coins, jewelry, gold, vintage watches & historical items',
  description:
    'Massachusetts\'s premier buyer of gold, silver, coins, currency, vintage watches, estate jewelry, and historical items. Free appraisals, fair prices, cash paid same day. Two convenient locations in West Bridgewater and Needham.',
  phone: '(508) 510-6332',
  phoneHref: 'tel:+15085106332',
  email: 'wbcoinandjewelry@gmail.com',
  domain: 'https://www.westbridgewatercoinandjewelry.com',
  googleRating: 4.9,
  googleReviewCount: 340,
  yearsExperience: 40,
  hours: {
    weekdays: 'Monday – Saturday: 10:00 AM – 5:00 PM',
    sunday: 'Sunday: Closed',
    short: 'Mon–Sat 10am–5pm',
  },
  locations: [
    {
      id: 'west-bridgewater',
      name: 'West Bridgewater',
      address: '455 West Center St',
      city: 'West Bridgewater',
      state: 'MA',
      zip: '02379',
      full: '455 West Center St, West Bridgewater, MA 02379',
      mapUrl: 'https://maps.google.com/?q=455+West+Center+St+West+Bridgewater+MA+02379',
      nearbyTowns: ['Brockton', 'Abington', 'Bridgewater', 'East Bridgewater', 'Whitman', 'Middleborough'],
    },
    {
      id: 'needham',
      name: 'Needham',
      address: '317 Chestnut St',
      city: 'Needham',
      state: 'MA',
      zip: '02492',
      full: '317 Chestnut St, Needham, MA 02492',
      mapUrl: 'https://maps.google.com/?q=317+Chestnut+St+Needham+MA+02492',
      nearbyTowns: ['Newton', 'Wellesley', 'Natick', 'Dedham', 'Westwood', 'Boston'],
    },
  ],
  social: {
    facebook: 'https://www.facebook.com/wbcoinandjewelry/',
  },
  formspreeId: 'REPLACE_WITH_ID',
} as const
